/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Analytics from '@ublend-npm/aula-analytics';

/**
 * HOC for tracking analytics.
 * @param {Object} config object containing the HOC config
 * @param {String} config.eventName which event you want to report
 * @param {Function} config.mapPropsToEvent will get the current props
 * with a `state` property containing the redux state and should return the values
 * to include on the event
 * @returns A component wrapping the original one
 */
export default ({ eventName, eventProperties = {} }) =>
  (WrappedComponent) =>
  (props) => {
    const {
      match: { params: locationParams },
    } = props;
    useEffect(() => {
      Analytics.track({
        event: eventName,
        ...eventProperties,
        ...locationParams,
      });
    }, []);

    return <WrappedComponent {...props} />;
  };
